<template>
  <div class="r_c p_t bc_f5">
    <TopHead :title="title"></TopHead>
    <div class="rc_c">
      <div class="f_title l rcc_title">{{title}}</div>

      <van-pull-refresh v-model="loading" @refresh="onRefresh">
        <van-list
          :immediate-check="false"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >

          <div class="mr_items d_f p_r" v-for="(item,index) in list" :key="index" @click="$router.push('/ProductDetails?commodityId='+item.commodityId)">
            <van-image fit="cover" :src="item.commodityCoverOne"/>
            <!--<div class="p_a tag" :style="{ backgroundColor: item.bgColor }">{{item.commodityTypeName}}</div>-->
            <div class="flex_1">
              <div class="mrr_t">{{item.commodityName}}</div>

              <div class="tag blue d_i">主要负责人：{{item.duration}}</div>
              <div class="bottom">
                   <span>可预约</span>
                   <span class="check">查看 <van-icon name="arrow" color="#ff8038" /></span>
                </div>
              <!-- <div class="d_f ali_b j_s price">
                <span></span>
                <span class="red">￥<span>{{item.marketPrice ? item.marketPrice/100 : 0}}</span></span>
              </div> -->
            </div>
          </div>
        </van-list>
      </van-pull-refresh>

    </div>

  </div>
</template>

<script>
  export default {
    name: "RecommendedCourses",
    data() {
      return {
        title:this.$route.query.title ? '搜索结果' :'推荐课程',//或搜索结果

        refreshing:false,
        loading:true,
        finished:false,
        list:[],
        params:{
          commodityName:'',
          recommendFlag:1,
          mallFlag:1,
          pageIndex:1,
          pageSize:10,
        },
      }
    },
    created(){
      this.params.commodityName = this.$route.query.title ? this.$route.query.keyWords :'';
      this.params.recommendFlag = this.$route.query.title ? 0 : 1;
      this.listCommodity();

    },
    methods: {

      // 根据code获取课程
      listCommodity(){
        this.loading = true;
        this.$api.listCommodityRecommend(this.params).then(res => {
          this.loading = false;
          if (this.refreshing) {
            this.refreshing = false;
          }
          if(res.data.recordCount){
            this.list = this.list.concat(JSON.parse(JSON.stringify(res.data.rows)));
          }
          let list = res.data.rows;
          if (!list || list.length < this.params.pageSize) {
            this.finished = true;
          }
        })
      },
      onLoad(){
        let me = this;
        if(me.loading) return
        let page = me.params.pageIndex;
        page = page ? page + 1 : 1;
        this.params.pageIndex = page;
        this.listCommodity();
      },
      onRefresh(){
        this.list = [];
        this.finished = false;
        this.params.pageIndex = 1;
        this.listCommodity();
      },
    }
  }
</script>

<style scoped lang="scss">
  .mr_items{
    .price{
      .red{
        >span{
          font-size: 27px;
        }
        font-size: 20px;
      }
      font-size: 13px;
    }
    .mrr_t{
      height: auto;
      font-size: 16px;
      margin-bottom: 12px;
    }
    img{
      width: 116px;
      height: 116px;
      margin-right: 13px;
    }
    .tag{
      padding: 4px 7px;
      font-size: 12px;
      left: 15px;
      top: 10px;
      margin-bottom: 15px;
    }
    padding: 10px 15px;
  }
  .rc_c{
    .rcc_title{
      margin-bottom: 16px;
    }
    padding: 20px 13px;

  }
.blue{
    background: #24bddd;
  }
  .bottom{
    display: flex;
    span{
      display: block;
      font-size: 10px;
      color: #aaaaaa;
    }
    .check{
      margin-left: auto;
      color: #ff8038;
      i{
        position: relative;
        top: 1.5px;
      }
    }
  }
</style>
